import {disablePageScroll, enableScroll} from "../utils/scroll";

export default function () {
  const wrapper = document.querySelector('.wrapper');
  const btn = wrapper.querySelector('.menu-btn');

  btn.addEventListener('click', function () {
    if (wrapper.classList.contains('menu-shown')) {
      wrapper.classList.remove('menu-shown');
      enableScroll();
    } else {
      wrapper.classList.add('menu-shown');
      disablePageScroll(true);
    }
  });
}
